/* eslint-disable react/jsx-boolean-value */
import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import Modal, { ModalBody, ModalFooter } from '../../components/Modal';
import { ModalContext } from '../../context/ModalContext';

import './PortfolioModal.scss';

const PortfolioModal = ({ title, subtitle, pieces = [] }) => {
  const { hideModal } = useContext(ModalContext);

  return (
    <Modal
      closeable={true}
      title={title}
      onClose={hideModal}
      id="portfolio-modal"
    >
      <ModalBody>
        <>
          {subtitle && <h3>{subtitle}</h3>}

          <div className="portfolio-list">
            {!!pieces.length &&
              pieces.map((piece) => {
                return (
                  <div className="portfolio-piece" key={piece.file}>
                    <div
                      className="portfolio-image"
                      style={{ width: piece.size ? piece.size : '100%' }}
                    >
                      <img src={piece.file} alt="" />
                    </div>

                    <div className="portfolio-image-description">
                      {piece.description}
                    </div>
                  </div>
                );
              })}
          </div>
        </>
      </ModalBody>
      <ModalFooter cancellable={false} onAccept={hideModal} />
    </Modal>
  );
};

PortfolioModal.propTypes = {
  title: PropTypes.string.isRequired,
  subtitle: PropTypes.string,
  pieces: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
      size: PropTypes.string,
    })
  ).isRequired,
};

export default PortfolioModal;
